import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import $ from 'jquery';

const RouteViewerGoogleControl = ({
    route,
    user,
    state,
    onShowPoint,
    onHidePoint,
    onZoomChanged,
    onCenterChanged,
    visiblePoint
}) => {


    const mapRef = useRef(null);
    const zoomInRef = useRef(null);
    const zoomOutRef = useRef(null);
    const infoboxRef = useRef(null)
    const distanceUnit = user.preferredMeasurementUnits == 'Statute' ? 'mi' : 'km';
    const elevationUnit = user.preferredMeasurementUnits == 'Statute' ? 'ft' : 'm';
    const [google, setGoogle] = useState(null);

    var map;
    var overlay;

    useEffect(() => {
        if (!google) {
            var GoogleMapsLoader = require('google-maps');
            GoogleMapsLoader.KEY = 'AIzaSyDuapJ8ilJP2mie5BKeZfP_xyeCGiJGJLI';
            GoogleMapsLoader.load(function (google) {
                setGoogle(google);
            });
        }
    }, []);

    useEffect(() => {
        if (google) {
            setUpMap();
            loadRoute();
        }
    }, [google])

    useEffect(() => {
        if (google) {
            if (!map) {
                setUpMap();
            }
            map.setMapTypeId(state.mapType.variant);
            loadRoute();
        }
    }, [state.mapType.variant])

    useEffect(() => {
        if (google) {
            var imagesize = new google.maps.Size(8, 8);
            var imageorigin = new google.maps.Point(0, 0);
            var imageanchor = new google.maps.Point(4, 4);
            var image_blank = new google.maps.MarkerImage('/resources/images/routespot_blank.png', imagesize, imageorigin, imageanchor);
            var image = new google.maps.MarkerImage('/resources/images/routespot.png', imagesize, imageorigin, imageanchor);

            if (visiblePoint) {
                if (visiblePoint.state === "show") {
                    visiblePoint.marker.setIcon(image);
                    return
                }
                visiblePoint.marker.setIcon(image_blank);
            }
        }
    }, [visiblePoint])

    function setUpMap() {

        var mapOptions = {
            mapTypeControl: false,
            zoomControl: false,
            streetViewControl: true,
            streetViewControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM },
        };

        var el = document.getElementById("google-map");
        map = new google.maps.Map(el, mapOptions);
        map.setCenter({ lat: state.center.lat, lng: state.center.lng });
        map.setZoom(state.zoom)

        if (state.mapType.variant) {
            map.setMapTypeId(state.mapType.variant);
        }

        google.maps.event.addListener(map, 'tilesloaded', handleMapLoad);
        google.maps.event.addListener(map, 'zoom_changed', handleZoomChanged);
        google.maps.event.addListener(map, 'dragend', handleCenterChanged);
    }

    function handleMapLoad() {
        
        var zoomIn = zoomInRef.current;
        $(zoomIn).unbind('click');
        $(zoomIn).click(() => {
            let zoom = map.getZoom();
            zoom = zoom + 1
            map.setZoom(zoom);
            onZoomChanged(zoom);
        })

        var zoomOut = zoomOutRef.current;
        $(zoomOut).unbind('click');
        $(zoomOut).click(() => {
            let zoom = map.getZoom();
            zoom = zoom - 1
            map.setZoom(zoom);
            onZoomChanged(zoom);
        })
    }

    function handleZoomChanged(){
        let zoom = map.getZoom();
        onZoomChanged(zoom);
    }

    function handleCenterChanged() {
        let center = map.getCenter();
        onCenterChanged({ lat: center.lat(), lng: center.lng() });
    }

    function loadRoute() {

        var imagesize = new google.maps.Size(8, 8);
        var imageorigin = new google.maps.Point(0, 0);
        var imageanchor = new google.maps.Point(4, 4);
        var image_blank = new google.maps.MarkerImage('/resources/images/routespot_blank.png', imagesize, imageorigin, imageanchor);
        var image = new google.maps.MarkerImage('/resources/images/routespot.png', imagesize, imageorigin, imageanchor);
        var startMarker = new google.maps.MarkerImage('/resources/images/start-marker.png', new google.maps.Size(29, 50), imageorigin, new google.maps.Point(15, 47)),

            overlay = new google.maps.OverlayView();
        overlay.draw = function () { };
        overlay.setMap(map);

        if (route.routeId) {

            var start = new google.maps.Marker({
                position: new google.maps.LatLng(route.points[0].latitude, route.points[0].longitude),
                map: map,
                icon: startMarker,
                zIndex: 5,
                visible: true
            })

            var path = [];

            route.points.map((point, id) => {

                var latlng = new google.maps.LatLng(point.latitude, point.longitude);
                latlng.distanceAtPoint = point.distanceAtPoint;

                point.distanceMarker = new google.maps.Marker({
                    position: latlng,
                    map: map,
                    icon: image_blank,
                    zIndex: 5,
                    visible: true
                });

                var infoboxTemplate = `<div class="google-infobox infobox"><ul><li>Distance: <b>${point.distanceAtPoint.toFixed(2)}</b> ${distanceUnit}</li><li>Elevation: <b>${point.elevation.toFixed(0)}</b> ${elevationUnit}</li></ul></div>`;

                var info = new google.maps.InfoWindow({
                    content: infoboxTemplate
                })
                point.distanceMarker.info = info;

                google.maps.event.addListener(point.distanceMarker, 'mouseover', function () {
                    this.setIcon(image);
                    showPointDetails(this.position);

                    var proj = overlay.getProjection();
                    var xy = proj.fromLatLngToContainerPixel(this.position);

                    var info = infoboxRef.current;

                    $(info).empty();
                    $(info).append(`<ul><li>Distance: <b>${point.distanceAtPoint.toFixed(2)}</b> ${distanceUnit}</li><li>Elevation: <b>${point.elevationAtPoint.toFixed(0)}</b> ${elevationUnit}</li></ul>`);

                    info.style.left = (xy.x - 43) + 'px';
                    info.style.top = (xy.y - 83) + 'px';
                    info.style.display = 'block'

                });
                google.maps.event.addListener(point.distanceMarker, 'mouseout', function () {
                    this.setIcon(image_blank);
                    hidePointDetails();

                    var info = infoboxRef.current;
                    info.style.display = 'none';
                });

                path.push(latlng)
            });

            var polyline = new google.maps.Polyline({
                map: map,
                path: path,
                strokeColor: '#14a4ff',
                strokeOpacity: 1.0,
                strokeWeight: 3
            })
        }
    }

    function showPointDetails(e) {
        onShowPoint(e)
    }

    function hidePointDetails(e) {
        onHidePoint();
    }

    return (
        <div className="google-container">
            <div className="zoom-controls btn-group" role="group">
                <button ref={zoomInRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-plus" /></button>
                <button ref={zoomOutRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-minus" /></button>
            </div>
            <div ref={mapRef} id="google-map"></div>
            <div ref={infoboxRef} className="google-infobox infobox"></div>
        </div>
    );
}

RouteViewerGoogleControl.propTypes = {
    route: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
    onShowPoint: PropTypes.func,
    onHidePoint: PropTypes.func,
    onZoomChanged: PropTypes.func,
    onCenterChanged: PropTypes.func,
    visiblePoint: PropTypes.object
}

export default RouteViewerGoogleControl;




// WEBPACK FOOTER //
// ./src/components/routes/RouteViewerGoogleControl.js